import { render } from "./SidebarList.vue?vue&type=template&id=4f981ec1&scoped=true"
import script from "./SidebarList.vue?vue&type=script&lang=js"
export * from "./SidebarList.vue?vue&type=script&lang=js"

import "./SidebarList.vue?vue&type=style&index=0&id=4f981ec1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f981ec1"]])

export default __exports__